import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import Label from "../../Label";
import {
  filterTextField,
  normalizeTextField,
} from "utils/helpers/validations";

const Simple = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  optional,
  right,
  trim = false,
  normalizeText = false,
  ...rest
}) => {
  const { onChange, onKeyUp, onBlur, onPaste, maxLength, ...inputRest } = rest;

  const cleanValue = (raw) => {
    let value = raw ?? "";
    if (trim) {
      value = value.replace(/\s+/g, "");
    }
    if (normalizeText) {
      value = filterTextField(value);
    }
    if (maxLength) {
      value = value.slice(0, maxLength);
    }
    return value;
  };

  const handleChange = (e) => {
    const value = cleanValue(e.target.value);
    if (value !== e.target.value) {
      e = { ...e, target: { ...e.target, value } };
    }
    onChange?.(e);
  };

  const handleBlur = (e) => {
    if (normalizeText) {
      const cleaned = normalizeTextField(e.target.value);
      if (cleaned !== e.target.value) {
        e = { ...e, target: { ...e.target, value: cleaned } };
        onChange?.(e);
      }
    }
    onBlur?.(e);
  };

  return (
    <div
      className={classnames(
        "input__lmf",
        { __error: touched && errors },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
        right={right}
      />
      <div className="input__lmf--field">
        <Input
          className={classnames({
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          ref={innerRef}
          {...inputRest}
          onChange={handleChange}
          onKeyUp={(e) => {
            onKeyUp?.(e);
            if (!trim) return;
            const cleaned = e.target.value.replace(/\s+/g, "");
            if (cleaned === e.target.value) return;
            e.target.value = cleaned;
            onChange?.({ ...e, target: { ...e.target, value: cleaned } });
          }}
          onPaste={(e) => {
            onPaste?.(e);
            if (!trim && !normalizeText) return;
            e.preventDefault();
            const value = cleanValue(e.clipboardData?.getData("text") ?? "");
            onChange?.({ ...e, target: { ...e.target, value } });
          }}
          onBlur={handleBlur}
        />
        {touched && errors && <p className="input--errors">{errors}</p>}
      </div>
    </div>
  );
};

Simple.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Simple.defaultProps = {
  label: "",
  placeholder: "",
};
export default Simple;
